import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { FeatureFlagService } from '@examdojo/core/feature-flag';
import { ExamDojoFeatureFlag, ExamdojoFeatureFlags } from '@examdojo/models/feature-flag';
import { EMPTY, startWith, switchMap, tap } from 'rxjs';
import { ExamdojoPlatformService } from '../../../shared/platform.service';
import { StudentClassService } from '../student-class/student-class.service';
import { StudentClassStore } from '../student-class/student-class.store';

@Injectable()
export class FetchStudentClassesEffect {
  constructor(
    private readonly studentClassService: StudentClassService,
    private readonly studentClassStore: StudentClassStore,
    private readonly errorHandlerService: ErrorHandlerService,
    private readonly featureFlagService: FeatureFlagService<ExamdojoFeatureFlags>,
    private readonly platformService: ExamdojoPlatformService,
  ) {
    if (this.featureFlagService.get(ExamDojoFeatureFlag.Classes)) {
      this.platformService.trigger$
        .pipe(
          startWith(null),
          switchMap(() =>
            this.studentClassService.fetchAllClasses().pipe(
              tap(() => this.studentClassStore.updateProp('initialized', true)),
              this.errorHandlerService.catchHttpErrors(() => EMPTY),
            ),
          ),
          takeUntilDestroyed(),
        )
        .subscribe();
    }
  }
}
